import React from "react";
import { Navigate } from "react-router-dom";
import { auth, db } from "../../firebase-config";
import { signOut, onAuthStateChanged } from "firebase/auth";
import { useState, useEffect } from "react";
import PleaseLoginToAccessThisPage from "./PleaseLoginToAccessThisPage";
import AddressAddDisplay from "./UserAddresses/AddressAddDisplay";
import { doc, setDoc, getDocs, collection } from "firebase/firestore";
import LoadScreen from "../LoadScreen";
import { H1 } from "ui-neumorphism";
const Profile = () => {
  const [redirect, setRedirect] = useState(false);
  const [user, setUser] = useState(true);
  const [userId, setUserId] = useState("");
  const [valid, setValid] = useState(false);
  const [loading, setLoading] = useState(true);
  const [address, setAddress] = useState([]);
  const [collectionStr, setCollectionStr] = useState("");

  auth.onAuthStateChanged((user) => {
    const currentUserInApp = auth.currentUser;
    if (currentUserInApp) setCollectionStr(auth.currentUser.uid);

    if (!collectionStr) setLoading(false);

    const collectionRef = collection(db, collectionStr + "+Address");

    const getProducts = async () => {
      const data = await getDocs(collectionRef);
      setAddress(
        data.docs.map((doc) => ({
          ...doc.data(),
        }))
      );
    };

    if (currentUserInApp) {
      setUserId(auth.currentUser.email);
      setLoading(false);
    }

    if (address && currentUserInApp) {
      setLoading(false);
      setValid(true);
    }

    getProducts();
  });

  const saveNewAddress = (name, pincode, apartmentNo, landmark) => {
    setDoc(doc(db, auth.currentUser.uid + "+Address", name), {
      name: name,
      pincode: pincode,
      apartmentNo: apartmentNo,
      landmark: landmark,
    });
  };

  return (
    <div>
      {loading && <LoadScreen />}

      {valid ? (
        <div>
          Welcome {userId}
          <AddressAddDisplay />
        </div>
      ) : (
        <PleaseLoginToAccessThisPage />
      )}
      {valid && address.length > 0 ? (
        <table className="table  text-center">
          <tbody>
            {address.map((i, index) => (
              <tr key={index}>
                {/* <th scope="row">{index + 1}</th> */}
                <th scope="row">
                  <img src={i.productImage} style={{ width: "4rem" }} />
                </th>
                <td>Name- {i.name} </td>
                <td>Aparment- {i.apartmentNo}</td>
                <td> Pin- {i.pincode}</td>
                <td> Landmark- {i.landmark}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <h1>Address not existing</h1>
      )}
    </div>
  );
};

export default Profile;
